<article class="search-result">
  <h2>
    <a [routerLink]="['/materiaali', result.id]" class="text-reset">{{ materialName }}</a>
  </h2>

  <div class="row">
    <div class="col-3 col-md-2">
      <img [src]="thumbnailUrl" class="img-fluid mb-3" [alt]="'demo.educationalMaterial.cover.alt' | translate" />
    </div>

    <div class="col-9 col-md-6">
      @if (description) {
        <p>{{ description }}</p>
      }

      <ul class="list-unstyled">
        @for (author of result.authors; track author) {
          <li>
            @if (author.authorname !== '') {
              {{ author.authorname }}
              @if (author.organization) {
                ({{ author.organization }})
              }
            }
            @if (author.authorname === '') {
              {{ author.organization }}
            }
          </li>
        }
      </ul>
    </div>

    <div class="col-12 col-md-4">
      <ul class="nav">
        <li class="nav-item">
          <a [routerLink]="['/materiaali', result.id]" class="nav-link">
            <i class="fa fa-fw fa-folder-o text-dark" aria-hidden="true"></i>
            {{ "search.results.open" | translate }}
          </a>
        </li>
        @if (result.hasDownloadableFiles) {
          <li class="nav-item">
            <a [href]="downloadUrl" download class="nav-link">
              <i class="fa fa-fw fa-download text-dark" aria-hidden="true"></i>
              {{ "search.results.download" | translate }}
            </a>
          </li>
        }
      </ul>

      @if (result.educationalLevels?.length > 0) {
        <div class="tags">
          <span class="visually-hidden" [id]="'result-educationalLevels' + result.id">
            {{ "collections.meta.educationalLevels" | translate }}
          </span>
          @for (level of result.educationalLevels; track level) {
            <button
              type="button"
              class="btn btn-light"
              [attr.aria-labelledby]="'result-educationalLevels' + result.id"
              (click)="filterSearch(level.educationallevelkey, level.value)">
              {{ level.value }}
            </button>
          }
        </div>
      }
      <!--educationalLevels-->
    </div>
  </div>

  <div class="row justify-content-between">
    <div class="col-auto">
      <span class="me-4">
        <img
          src="assets/img/icons/learning-resource-types/{{result.learningResourceTypes[0].learningresourcetypekey}}.svg"
          class="img-icon"
          aria-hidden="true" />
        {{ result.learningResourceTypes[0].value }}
      </span>

      <strong>{{ result.license.value }}</strong>
    </div>

    <div class="col-auto">
      <time [attr.datetime]="result.createdAt | date: 'yyyy-MM-dd'">{{ result.createdAt | date: "d.M.yyyy" }}</time>
    </div>
  </div>
</article>
